import {Warning} from "@mui/icons-material";
import {Alert} from "@mui/material";
import {useLoggedOutFee} from "@/components/Providers/LoggedOutFeeProvider.tsx";

const CompleteFeeCard = () => {
    const {fee} = useLoggedOutFee();

    if (fee === null) {
        return <></>;
    }

    return (
        <>
            {fee.saleEndDateCommunityMemberEnded &&
                fee.saleEndDateGuestEnded &&
                fee.saleEndDateStudentEnded &&
                fee.saleEndDateEmployeeEnded && (
                    <Alert icon={<Warning fontSize="inherit" />} severity="warning" sx={{mt: 2}}>
                        Sale of this fee has ended. You can still login and see other fees but you
                        will not be able to buy this fee.
                    </Alert>
                )}
        </>
    );
};

export default CompleteFeeCard;
